module.exports = __webpack_public_path__ + "static/6305-woodrose-7-80eeef2568d9468a84fa3e5641d6ee97.jpg";